module.exports = __webpack_public_path__ + "static/media/2.a33e3a0e.png";